import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import PageLoading from '@/components/Common/PageLoading';
import { getDefaultWorkspaceHref } from '@/features/Commons/Sidebar/model/sidebar-schema';

import service from '../../services';
import useUserStore from '../../stores/UserStore';
import useWorkspaceStore from '../../stores/WorkspaceStore';

const AppIndex = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, user } = useUserStore((state) => ({
    setUser: state.setUser,
    user: state.user,
  }));
  const { currWorkspace, workspaces, fetchWorkspace, fetchWorkspaces } =
    useWorkspaceStore((state) => ({
      currWorkspace: state.currWorkspace,
      workspaces: state.workspaces,
      fetchWorkspace: state.fetchWorkspace,
      fetchWorkspaces: state.fetchWorkspaces,
  }));

  const wa = currWorkspace?.alias;
  useEffect(() => {
    let isActive = true;

    const checkStorage = (): string | false => {
      if (user) {
        const alias = localStorage.getItem(`curr_workspace_${user.user_id}`);
        return alias || false;
      }
      return false;
    };

    const request = (alias: string) => {
      navigate(`/request-access/${alias}`, { replace: true });
    };

    if (user) {
      if (user.hasWorkspace && workspaces.length === 0) {
        void fetchWorkspaces().catch((error: unknown) => {
          if (!isActive) return;

          console.error('[app-index] workspace bootstrap failed', error);
          navigate('/500', { replace: true });
        });
      } else {
        const alias = checkStorage();
        if (alias) {
          void fetchWorkspace(alias, () => request(alias));
        } else {
          void fetchWorkspace(
            workspaces[0].alias,
            () => request(workspaces[0].alias),
          );
        }
      }
    } else {
      void (async () => {
        try {
          const data = await service.auth.authCheck();
          if (data && data.workspaces?.length) {
            setUser({
              user_id: data.user_id,
              firstName: data.first_name,
              lastName: data.last_name,
              email: data.email,
              hasWorkspace: true,
              color: data.color,
            });
          } else {
            navigate('/login', { replace: true });
          }
        } catch (error: unknown) {
          console.error('[app-index] auth bootstrap failed', error);
          navigate('/login', { replace: true });
        }
      })();
    }

    return () => {
      isActive = false;
    };
  }, [
    user,
    navigate,
    setUser,
    workspaces,
    fetchWorkspaces,
    fetchWorkspace,
    location.pathname,
  ]);

  useEffect(() => {
    if (location.pathname !== '/') return;
    if (wa) {
      navigate(`/workspace/${wa}${getDefaultWorkspaceHref()}`);
    }
  }, [wa, navigate, location.pathname]);

  return (
    <PageLoading
      style={{ position: 'relative' }}
      wrapperStyle={{ backgroundColor: 'transparent' }}
    />
  );
};

export default AppIndex;
